import Axios from "./axios";

const resource = "callback-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}